module.exports = __webpack_public_path__ + "394921d7e0c7350a08374845f5135344.svg";